import { Spinner } from "react-bootstrap";

const dynamicSize = {
    small: {
        width: "1.5rem",
        height: "1.5rem",
    },
    medium: {
        width: "2.5rem",
        height: "2.5rem",
    },
    large: {
        width: "5rem",
        height: "5rem",
    },
};

function LoadingIndicator(props) {
    return (
        <div className="d-flex flex-column align-items-center my-4">
            <Spinner animation="border" role="status" style={dynamicSize[props.size]}>
                <span className="visually-hidden">{props.message}</span>
            </Spinner>
        </div>
    );
};

export default LoadingIndicator;
